import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import { getBlogPosts } from '../services/api';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const data = await getBlogPosts();
        const sorted = [...data].sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
        setPosts(sorted);
      } catch (error) {
        console.error('Failed to load blog posts:', error);
        setPosts([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadPosts();
  }, []);

  return (
    <div className="rkblog-page">
      <div className="rkblog-hero">
        <div className="container rkblog-container">
          <h1 className="rkblog-title">rkube Blog</h1>
          <p className="rkblog-subtitle">Insights, tips, and updates from rkube Services on accounting, tax, and business</p>
        </div>
      </div>

      <div className="rkblog-content">
        <div className="container rkblog-container">
          {isLoading && (
            <div className="rkblog-empty-state">
              <h2 className="rkblog-empty-title">Loading articles...</h2>
            </div>
          )}

          {!isLoading && posts.length > 0 && (
            <div className="rkblog-posts-grid">
              {posts.map((post) => (
                <article key={post.slug} className="rkblog-card">
                  <p className="rkblog-card-meta">
                    {new Date(post.publishedAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </p>
                  <h2 className="rkblog-card-title">{post.title}</h2>
                  <p className="rkblog-card-excerpt">{post.excerpt}</p>
                  <Link className="rkblog-read-link" to={`/blog/${post.slug}`}>
                    Read article
                  </Link>
                </article>
              ))}
            </div>
          )}

          {!isLoading && posts.length === 0 && (
            <div className="rkblog-empty-state">
              <h2 className="rkblog-empty-title">No posts yet</h2>
              <p className="rkblog-empty-message">Add a JSON file in your configured blog folder to publish.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Blog;